export interface IOffersForSpecificNewbuildingSearchSliderNewbuilding {
  id: number;
  name: string;
  url: string;
}

export interface IOffersForSpecificNewbuildingSearchSliderUnderground {
  name?: string | null;
  cityType?: ECityType | null;
  lineColor?: string | null;
  timeDisplay: string;
  transportType: ETransportType;
}

export enum ECityType {
  'Msk' = 'msk',
  'Spb' = 'spb',
  'Samara' = 'samara',
  'Ekb' = 'ekb',
  'Kazan' = 'kazan',
  'Nizhniy' = 'nizhniy',
  'Novosib' = 'novosib',
}
export enum ETransportType {
  'Walk' = 'walk',
  'Transport' = 'transport',
}

export interface INewbuildingOffer {
  id: number;
  imageUrl: string;
  cardUrl: string;
  newbuilding: IOffersForSpecificNewbuildingSearchSliderNewbuilding;
  priceDisplay: string;
  description: string;
  underground?: IOffersForSpecificNewbuildingSearchSliderUnderground | null;
  newbuildingAddress?: string | null;
  companyLogoUrl?: string | null;
}
